var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggCornSyrup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7832 29.6822C24.318 27.2915 21.4241 24.5587 20 22.5C18.6165 20.5 19 17.5945 14.8893 17.5945C13.1948 17.5945 11.4846 19.7401 9.5 22C7.35389 24.4438 4.99532 27.106 4.99536 29.6822C4.99544 34.6407 7.51465 40.2083 14.8893 40.2083C22.264 40.2083 25.8826 35.5663 24.7832 29.6822Z",
    fill: "url(#paint0_radial_10256_11688)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0272 30.5C22.0272 34.833 19.4488 39.3455 15.0346 39.3455C10.6203 39.3455 8.04193 34.833 8.04193 30.5C8.04193 26.167 10.6203 21.6179 15.0346 21.6179C17.5 21.6179 22.0272 26.167 22.0272 30.5Z",
    fill: "url(#paint1_radial_10256_11688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10256_11688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8892 30.4014) rotate(90) scale(9.8069 10.0876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10256_11688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 31) rotate(180) scale(7 8.72854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggCornSyrup);
export default __webpack_public_path__ + "static/media/egg_corn_syrup.63652fb5ced1cd8bb83bf4aacd2f4332.svg";
export { ForwardRef as ReactComponent };